<template>
  <div id="miximenu">
    <div class="row">
      <div class="large-12 medium-12 small-12 columns"><p></p>
        <h2 class="pcg-title" v-html="baseView.mixiChecked ? currFullDef.readable : currPkg.readable"></h2>
        <hr>
      </div>
    </div>
    <div v-show="baseView.addInfo">
    <div v-if="!baseView.mixiChecked">
    <div class="row">
      <div class="large-12 medium-12 small-12 columns">
        <div class="sub-content mixi_list" v-bind:class="{ active: currPkg.isChecked}" v-on:click="pcgVis(currPkg.bucketName)" v-for="(currPkg, pix) in baseView.currMixiArr" :key="pix + '-' + currPkg.uniqElName">
          <img class="m_list" src="graphics/ico_color_bullet.png"/>
          <div class="pcg-block-left magenta1">{{ currPkg.readable }}<br />
            <span class="mixi-badge" v-show="currPkg.badge" v-html="currPkg.badge" />
          </div>
          <div class="pcg-block-right">
            <div><span v-bind:class="{ 'color-magenta': currPkg.multiPrice, 'pcg_right': !formatPrice(currPkg.price, true).isFree, 'pcg_right_long': formatPrice(currPkg.price, true).isFree }" v-html="formatPrice(currPkg.price, true).value"></span></div>
            <div v-if="currPkg.multiPrice"><span v-html="formatPrice(currPkg.altPrice, false).value"></span></div>          
          </div>
        </div>
        <div v-if="hasM1">
          <p></p>
          <div class="type_title" v-html="tpl('package.viewMixi.magenta1Title')"></div>
          <div class="sub-content mixi_list" v-bind:class="{ active: currPkg.isChecked}" v-on:click="pcgVis(currPkg.bucketName)" v-for="(currPkg, mix) in baseView.currMixiM1Arr" :key="mix + '-' + currPkg.uniqElName">
            <img class="m_list" src="graphics/ico_color_bullet.png"/>
            <div class="pcg-block-left magenta1"><span>{{ currPkg.readable }}</span><br />
            <span class="mixi-badge" v-if="currPkg.badge" v-html="currPkg.badge" />
            </div>
            <div class="pcg-block-right">
              <div><span v-bind:class="{ 'color-magenta': currPkg.multiPrice, 'pcg_right': !formatPrice(currPkg.price, true).isFree, 'pcg_right_long': formatPrice(currPkg.price, true).isFree }" v-html="formatPrice(currPkg.price, true).value"></span></div>
              <div v-if="currPkg.multiPrice"><span v-html="formatPrice(currPkg.altPrice, false).value"></span></div>          
            </div>
          </div>
        </div>
        <div v-if="hasSpec">
          <p></p>
          <div class="type_title" v-html="tpl('package.viewMixi.campaignTitle')"></div>
          <div class="sub-content mixi_list" v-bind:class="{ active: currPkg.isChecked}" v-on:click="pcgVis(currPkg.bucketName)" v-for="currPkg in baseView.currMixiSpecArr" :key="currPkg.bucketName">
            <img class="m_list" src="graphics/ico_color_bullet.png"/>
            <div class="pcg-block-left magenta1">{{ currPkg.readable }}<br />
            <span class="mixi-badge" v-show="currPkg.badge" v-html="currPkg.badge" />
            </div>
            <div class="pcg-block-right">
              <div><span v-bind:class="{ 'color-magenta': currPkg.multiPrice, 'pcg_right': !formatPrice(currPkg.price, true).isFree, 'pcg_right_long': formatPrice(currPkg.price, true).isFree }" v-html="formatPrice(currPkg.price, true).value"></span></div>
              <div v-if="currPkg.multiPrice"><span v-html="formatPrice(currPkg.altPrice, false).value"></span></div>          
            </div>
          </div>
        </div>
        <p></p>
        <hr />
        </div>
        </div>
        </div>
        <div v-else>
          <div class="roll_container">
            <div class="roll_top">
          <div class="row">
            <div class="large-12 medium-12 small-12 columns">
              <div class="mixi_back" v-on:click.prevent="pcgVis(currFullDef.bucketName)"><img src="../assets/img/ico_arrow_next.png" class="arrow_back" /><span class="text_back">Zmeniť výber</span></div>
              <div v-html="currFullDef.tplText" class="view_mixi"></div>
            </div>
            </div>
            </div>
            <div class="roll_target">
            <div class="row">
              <div class="large-12 medium-12 small-12 columns">
              <span>Platí do <strong>{{ currFullDef.validityText }}</strong></span>
              <a class="actions action a_white"  v-bind:class="{ check_fail: !baseView.mixiChecked }" v-on:click="callAction('start')">Aktivovať</a>
            </div>
            </div>
            </div>
          </div>
        </div>
        </div>
        <div v-if="baseView.addTYPage">
          <div class="row">
            <div class="large-12 medium-12 small-12 columns">
          <p v-html="baseView.TYText" v-bind:class="{ mActive: baseView.TYInfoAlert }"></p><p>&nbsp;</p>
            <a class="actions action" v-on:click="actionRel()" v-if="baseView.TYBtn">NÁVRAT NA PREHĽAD</a>
        </div>
        </div>
        </div>
      </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'mixiMenu',
  props: ['productdetail', 'tplData', 'states', 'pkgDef', 'nextPacks', 'mixiEligibleFull'],
  data () {
    return {
      msg: 'Mixi ponuka',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      fromTpl: {

      },
      baseView: {
        nextPacks: [], currMixiArr: [], currMixiSpecArr: [], currMixiM1Arr: [], currMixiAll: [], addInfo: true, addTYPage: false, TYBtn: false, TYText: '', TYInfoAlert: false, mixiChecked: false
      },
      moment: moment,
      currFullDef: {},
      daysAcc: ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty']
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    if (!this.$store.state.onlyMixPkg) {
      window.onpopstate = function(event) {
        window.history.replaceState(null, '')
        that.states.mainView = true 
        that.states.mixiMenuView = false
      }
    }

    var currMixiArr = [], currMixiSpecArr = [], currMixiM1Arr = [];
    var fromMixi = _.filter(that.pkgDef, { bucketName: 'Mixi' })[0];
    _.forEach(that.productdetail.mixMenu, function(pv, pk) {
      _.forEach(that.mixiEligibleFull, function(ev, ek) {
        if ((pv.bucketName === ev.bucketName) || ((pv.bucketName + '_M1') === ev.bucketName) || (pv.allBuckets.split('|').indexOf(ev.bucketName)) !== -1) {
          pv.price = ev.price;
          pv.priority = ev.priority || 9;
          pv.start = fromMixi.start;
          pv.uniqElName = ev.bucketName;
          pv.start.commandType = ev.bucketName.slice(-3) === '_M1' ? ev.bucketName.slice(0, -3) : ev.bucketName;
          pv.isChecked = false;
          pv.multiPrice = false;
          pv.altPrice = ev.price;
          pv.eligBadge = ev.badge;
          pv.validityText = that.daysAcc[(moment(that.productdetail.timeStamp).add((pv.periodDays || 0), 'days').format('d'))] + ', ' + moment(that.productdetail.timeStamp).add((Math.round(parseInt(pv.periodDays || 0))) * 24, 'hour').format('D.M.YYYY H:mm')
          if (pv.typeCount > 1 && parseFloat(ev.price) > 0) {
            pv.multiPrice = true;
            pv.altPrice = parseFloat(ev.price) + (0.25 * pv.typeCount);
          }
          if (pv.periodType === 'campaign') {
            currMixiSpecArr.push(_.cloneDeep(pv))                      
          }
          if (pv.periodType === 'legacy') {
            if (ev.bucketName.slice(-3) === '_M1') {
              currMixiM1Arr.push(_.cloneDeep(pv))          
            } else {
              currMixiArr.push(_.cloneDeep(pv))          
            }
          }
        }
      })
    })
    currMixiArr = _.orderBy(currMixiArr, ['priority'], ['asc']);
    this.baseView.currMixiSpecArr = currMixiSpecArr;
    this.baseView.currMixiM1Arr = currMixiM1Arr;
    this.baseView.currMixiArr = currMixiArr;
    this.baseView.currMixiAll = _.concat(currMixiArr, currMixiSpecArr, currMixiM1Arr);
    if (this.baseView.currMixiAll.length === 0) {
      this.actionRel();
    } else {  
      _.forEach(this.baseView.currMixiAll, (xa) => {
        if (xa.eligBadge !== null) {
          xa.badge = xa.eligBadge;
        }
      })
    }
    window.onresize = function() {
      if (document.querySelector('.roll_container') !== null) {
        that.setBtnHeight()
      }
    }
 },
  mounted: function() {

  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    currPkg: function() {
      var res = _.filter(this.pkgDef, { 'bucketName': 'Mixi'})[0];
      return res
    },
    isProd: function() {
      if ((window.location.hostname == "m.telekom.sk") && (this.$store.state.activeAnalytic)) {
        return true
      } else {
        return false
      }
    }, 
    hasSpec: function() {
      return this.baseView.currMixiSpecArr.length > 0;
    }, 
    hasM1: function() {
      return this.baseView.currMixiM1Arr.length > 0;
    }
  }, 
  methods: {
    pcgVis: function(currPkg) {
      var that = this;
      this.baseView.mixiChecked = false;
      _.forEach(this.baseView.currMixiAll, function(cv, ck){
        if (cv.bucketName === currPkg) {
          cv.isChecked = !cv.isChecked
          that.baseView.mixiChecked = cv.isChecked;
          if (cv.isChecked) {
            that.currFullDef = cv;
            that.$nextTick(function(){
              that.setBtnHeight();              
            })
          } else {
            that.currFullDef = {};
          }
        } else {
          cv.isChecked = false;
        }
      })
    },
    setBtnHeight: function() {
      const dispHeight = (window.innerHeight - 88 - (Math.round(parseFloat((window.getComputedStyle(document.querySelector('.pcg-title')).height).replace(/px/i, '')))));
      document.querySelector('.roll_container').style.height = dispHeight + 'px';
      document.querySelector('.roll_top').style.height = (dispHeight - 99) + 'px';
    },
    formatPrice: function (virgin, active) {
      if (active) {
        let res = parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €";
        let isFree = (parseFloat(virgin) === 0);
        return { value: isFree ? (this.tplData.package?.viewMixi?.zeroPrice || 'bezplatne') : res, isFree: isFree }
      } else {
        return { value: parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €", isFree: false }
      }
    },    
    callAction: function(fAction) {
      var actionPkg = this.currFullDef;
      var that = this, ext2 = 'mweb';
      this.baseView.addTYPage = true, this.baseView.addInfo = false, this.baseView.TYText = this.tplData.credit.httpCallWait, this.baseView.TYInfoAlert = false
      if (this.baseView.mixiChecked) {
      this.$http.put('/pb/easy-api/packages', { name: actionPkg.commgroup, ext: [actionPkg.start.commandType, ext2] })
        .then(function (resp) {
            that.baseView.TYText = that.tplData.credit.httpCallSuccess
            that.$store.dispatch('refreshProductDetail')
            if ((fAction == 'start') && (that.isProd)) {
              var dlName = actionPkg.commgroup + '_' + actionPkg.start.commandType
              dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': new Date().getTime().toString(), 
                      'affiliation': 'm.telekom',
                      'revenue': actionPkg.price
                    },
                    'products': [{
                      'name': dlName,  
                      'id': 'SC0001',
                      'price': actionPkg.price,
                      'brand': 'm.telekom',
                      'category': 'VAS',
                      'quantity': 1
                    }]
                  }
                }
              });                 
            }
        })
        .catch(function(error){
          var resText = that.tplData.credit.httpCallFail
          if (error.response.status === 403) {
            window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
          } else {
            that.baseView.TYInfoAlert = true
            try {
                if ((error.response.data.message).indexOf('NOK-Insufficient credit') != -1) {
                    resText = that.tplData.package.denyNoCredit
                }
                if ((error.response.data.message).indexOf('NOK-not allowed') != -1) {
                    resText = that.tplData.package.denyNewHttpCall
                }
                if ((error.response.data.message).indexOf('Not Acceptable') != -1) {
                    resText = "Aktivácia zvoleného balíčka momentálne nieje možná.";
                }
                if ((error.response.data.message).toLowerCase().indexOf('no response from') != -1) {
                    that.baseView.TYInfoAlert = false
                    resText = "Požiadavka bola odoslaná, výsledok spracovania potvrdíme SMS správou."
                    that.$store.dispatch('refreshProductDetail')
                }
            }
            catch(e) {}
            that.baseView.TYText = resText
          }
        })
        .finally(function() {
          that.baseView.TYBtn = true
        })
      }
    },
    actionRel: function()  {
      this.states.viewAllow = false
      this.states.mixiMenuView = false
      location.reload()
    },
    formatMsisdn: function(virgin) {
      return '0' + String(virgin || '').substr(-9)
    }
  }
}
</script>

<style scoped>

a {
  text-decoration: none;
}

a.pcg-btm {
  text-decoration: underline;
}

.sub-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.sub-content {
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset;
}

.pcg-block-left {
  font-family:'TeleGroteskFet';
  cursor: pointer;
  align-self: center;
  position: relative;
  padding-right: 26px;
}

.pcg-block-right {
  align-self: center;
  text-align: end;
  flex: 1;
}

.pcg-block-right > div:first-child {
  margin-top: 4px;
}

.pcg-block-right > div:nth-child(2) {
  padding-right: 3px;
  text-decoration: line-through;
/* 
  color: #8f8f8f;
 */
}

.a_white {
  background-color: #ffffff;
}

.a_white:active {
  background-color: #e20074;
}

.mixi_back {
  font-family:'TeleGroteskFet';
  color: #e20074;
  cursor: pointer;
}

.mixi_back .arrow_back {
  rotate: 180deg;
  height: 16px;
  position: relative;
  bottom: 2px;
  left: -3px;
  margin-right: 4px;
}

.mixi_back .text_back:hover, .mixi_back .text_back:active {
  color: #b6005e;
}

.type_title {
  font-family:'TeleGroteskFet';
  text-decoration: underline;
  margin-bottom: 4px;
}

.pcg_right {
  font-size: 1.7rem;
  white-space: nowrap;
}

.pcg_right_long {
  color: #e20074;
  white-space: nowrap;
  font-family:'TeleGroteskFet';
}

.pcg-title {
  text-transform: uppercase;
}

.cState {
  color: #e20074;
  font-weight: bold;
}

.pcg_new {
  margin-bottom: 3rem;
}

.roll_target {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 7px 0 6px;
  background-color: #e8e8e8;
}

.roll_container {
  position: relative;
}

.roll_top {
  overflow-y: scroll;
}

.action {
  margin: 5px 0 10px;
}

.m_list {
  margin-right: 8px;
  align-self:center;
  height: 9px;
}

a.check_fail {
  pointer-events: none;
  color: #383838;;
  border: 2px solid  #a4a4a4;
  background-color: #ededed;
  font-weight: 400;
}
</style>
